import { Component, ElementRef, HostListener, OnInit, ViewChild, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Contact } from 'src/app/_models/contact.model';
import { AuthService } from 'src/app/_services/auth.service';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import 'jquery';
import 'bootstrap';
import { CommerceFileDocumentModel } from 'src/app/_models/commerceFilesDocumentPost.model';
import { CommerceFileDocumentService } from 'src/app/_services/commercefile-document.service';
import { CommerceFileDocumentModelGet } from 'src/app/_models/commerceFilesDocumentGet.model';
import { Routes } from 'src/app/_config/routes.config';
import { ContactGroupService } from 'src/app/_services/contact-group.service';
import { User } from 'src/app/_models/user.model';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { PagesService } from 'src/app/_services/pages.service';

@Component({
  selector: 'DCO-documents',
  templateUrl: './documents.component.html',
  standalone: false,
})
export class DocumentsComponent extends BaseComponent implements OnInit {
  // valores generales
  loadCompleted: boolean = false;
  contactGroupId: any;
  documentTypes: string[] = [
    'GENERAL_CONDITIONS',
    'CANCELLATION_POLICY',
    'DENIAL_POLICY',
    'OTHER DOCUMENTS',
    // 'SaleConditions',
    // 'CancellationPolicy',
    // 'PurchaseProcess',
    // 'OtherDocuments',
  ];

  //documentAssignments: Record<string, AssignedDocuments[]> = {};
  documentAssignments: Record<string, CommerceFileDocumentModelGet[]> = {};
  showInfoEnrollment: boolean = false;
  lstContacts: Contact[] = [];
  // valores generales
  // propiedades modal
  @ViewChild('assigDocumentModal') modalAssingDocuments: ElementRef;
  @ViewChild('modalFileInput') modalFileInput: ElementRef;
  // modal resultado
  @ViewChild('postFilemodal') modalPostFile: ElementRef;

  modalSelectedType: string = '';
  modalDisabled = true;
  lstContactsInModal: Contact[] = [];
  documentAssignSelectedContacts = {}; // para guardar los contactos seleccionados
  documentAssignFileBase64 = '';
  documentAssignSizeFileError = false;
  documentAssignExtensionFileError = false;
  documentAssignFileError = false;
  documentAssignName = '';
  documentAssignSize = 0;
  documentAssignType = '';
  boolAnyContactsAssigned = false;
  boolCheckedAll = false;
  // propiedades modal
  //
  tokenData: any;
  username: string;
  menuAbierto = false;
  languages = [];
  private languageChanged$!: Subscription;
  public selectedLanguage = '';
  private userSuscription$!: Subscription;
  private languagesDownloaded$!: Subscription;
  openDocumentKey: string | null = null;

  getCommercefilesDocument: CommerceFileDocumentModelGet[];
  parameters: CommerceFileDocumentModel = new CommerceFileDocumentModel();

  constructor(
    public override router: Router,
    public override langService: LanguageManagerService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private contactGroupService: ContactGroupService,
    private CommerceFileDocumentService: CommerceFileDocumentService,
    private storageService: StorageService,
    private _pagesService: PagesService,
  ) {
    super(router, langService, route);
  }

  @HostListener('document:click')
  clickOut() {
    this.menuAbierto = false;
  }

  toggleDocumentAccordion(key: string) {
    this.openDocumentKey = this.openDocumentKey === key ? null : key;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.tokenData = this.authService.getTokenData();
    // Usamos "query params" para recibir el contactGroupId del método "next" en el contact-data.component
    this.route.queryParams.subscribe((params) => {
      this.contactGroupId = params['contactGroupId'];
      this.documentTypes.map((doc) => {
        this.documentAssignments[doc] = [];
      });
      this.ContactsGet().subscribe({
        next: (contactList) => {
          this.lstContacts = contactList;
          this.ContactsSetDefaultDictionary();
          this.documentTypes.map((doc) => {
            // Se mapea el documentType del front con el del back
            // Se hace la llamada al endpoint para conseguir los documentos de cada documentType
            this.CommerceFileDocumentService.GetCommerceFileDocument(
              doc,
            ).subscribe({
              next: (response) => {
                this.documentAssignments[doc] = response;
              },
            });
            this.loadCompleted = true;
          });
        },
        error: (error) => { },
      });
    });
    this.userSuscription$ = this.storageService.userInfo.subscribe((user) => {
      // si se moficia el usuario (login o logout)
      // recibimos el evento, actualizamos el nombre que se ve (o ponemos login)
      this.updateUserData(user);
      // actualizamos las paginas visibles para el usuario
      this._pagesService.Pages_Get();
    });
    this.languagesDownloaded$ = this.langService.languagesDownloaded$.subscribe(
      (languages) => {
        // cuando termina de cargar los idiomas mostramos el desplegable
        // console.log('enrollment languages',languages)
        this.languages = languages;
      },
    );
    this.languageChanged$ = this.langService.languageChanged$.subscribe(
      (selectedLanguage) => {
        // console.log('enrollment selectedLanguage',selectedLanguage)
        // cuando recibimos el evento de cambiar de idioma cambiamos la seleccion del desplegable
        // eso ocurre al cargar la pagina, el desplegable puede poner el primer valor
        // pero podemos tener guardado un idioma determinado seleccionado
        this.selectedLanguage = selectedLanguage;
      },
    );
  }

  updateUserData(user: User) {
    if (user) {
      this.username = user.user;
    } else {
      this.username = null;
    }
  }

  logOut() {
    this.authService.logOut();
    this.router.navigate([Routes.LOGIN]); // Redirige al usuario a la página de login
  }

  SetLanguage(lang: any) {
    this.langService.SetLanguage(lang);
  }

  selectLanguage(language: any) {
    this.langService.SetLanguage(language);
  }

  ContactsGet() {
    return this.contactGroupService.getContactsByContactGroupId(
      this.contactGroupId,
    );
  }
  ContactsSetDefaultDictionary(checked = false) {
    this.lstContacts.map((c) => {
      this.documentAssignSelectedContacts[c.contactId] = checked;
    });
  }
  // borrar assignedDocument
  DocumentAssignmentClear(documentType, index, commerceFileId) {
    let currentDocumentAssigments = this.documentAssignments[documentType];
    currentDocumentAssigments.splice(index, 1);
    this.documentAssignments[documentType] = currentDocumentAssigments;
    this.CommerceFileDocumentService.DeleteCommerceFileDocument(
      commerceFileId,
    ).subscribe({ next: (response) => { } });
  }

  // revisa el tipo de documento y si no quedan contactos por asociar devuelve desabilitado
  CheckDocumentAssignmentModalDisabled(
    documentType,
    documentAssignments: CommerceFileDocumentModelGet[],
  ) {
    let currentAssignedContacts = [];
    if (documentType != 'OTHER_DOCUMENTS') {
      /* // console.log(documentType)
    if (documentType != 'OtherDocuments') {
      for(let i=0; i<this.documentAssignments[documentType].length; i++){
        currentAssignedContacts.push(this.documentAssignmentsId[documentType][i] = true);
    } */
      documentAssignments.map((da) => {
        da.contacts.map((c) => {
          currentAssignedContacts[c.contactId] = true;
        });
      });
    }
    return (
      this.lstContacts.filter(
        (contact) => !currentAssignedContacts.hasOwnProperty(contact.contactId),
      ).length == 0
    );
  }
  // Muestra el modal con la lista de contactos disponible para ese tipo
  ShowDocumentAssignmentModal(
    documentType,
    documentAssignments: CommerceFileDocumentModelGet[],
  ) {
    //event.stopImmediatePropagation();
    //event.stopPropagation();
    this.ClearUploadedDocument();
    this.modalSelectedType = documentType;
    this.lstContactsInModal = [];
    this.boolAnyContactsAssigned = false;
    this.boolCheckedAll = false;
    this.ContactsSetDefaultDictionary();
    // obtenemos el diccionario de los contactos que ya estan asignados para este documento
    // salvo si es otros, en cuyo caso no hay limite
    // se hace diccionrio y no lista para facilitar la busqueda después
    let currentAssignedContacts = {};
    if (documentType != 'OTHER_DOCUMENTS') {
      documentAssignments.map((da) => {
        da.contacts.map((c) => {
          currentAssignedContacts[c.contactId] = true;
        });
      });
    }
    this.lstContactsInModal = this.lstContacts.filter(
      (contact) => !currentAssignedContacts.hasOwnProperty(contact.contactId),
    );
    // this.lstContactsInModal.map((contact) => {
    //   contact.lastUpdateBy = this.storageService.getGuid();
    // });
    this.lstContactsInModal = [...this.lstContactsInModal];
    $(this.modalAssingDocuments.nativeElement).modal('show');
  }
  // seleccionar contacto
  onCheckedContact(value: number, event: Event) {
    if (value == -1) {
      // check or uncheck all
      let isChecked = (<HTMLInputElement>event.target).checked;
      this.lstContactsInModal.map((contactInModel) => {
        this.documentAssignSelectedContacts[contactInModel.contactId] =
          isChecked;
      });
    } else {
      this.documentAssignSelectedContacts[value] = (<HTMLInputElement>(
        event.target
      )).checked;
    }
    this.boolAnyContactsAssigned = this.lstContacts.some(
      (contact) =>
        this.documentAssignSelectedContacts[contact.contactId] == true,
    );
  }
  // gestionar el documento subido
  onModalDocumentUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    this.documentAssignSizeFileError = false;
    this.documentAssignExtensionFileError = false;
    //console.log(this.modalSelectedType)

    if (!input.files?.length) {
      this.ClearUploadedDocument();
      return;
    } else {
      const file = input.files[0];

      const maxSizeInBytes = 10 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        input.value = '';
        this.ClearUploadedDocument();
        this.documentAssignSizeFileError = true;
        return;
      }

      const allowedExtensions = ['pdf', 'docx', 'doc', 'jpg', 'jpeg', 'png'];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();

      if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
        input.value = '';
        this.ClearUploadedDocument();
        this.documentAssignExtensionFileError = true;
        return;
      }

      this.documentAssignSize = Math.round(file.size / 1024);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.documentAssignFileBase64 = reader.result
          .toString()
          .replace('data:', '')
          .replace(/^.+,/, '');
      };
      this.documentAssignName = file.name;
      this.documentAssignType = file.type;
      this.documentAssignSizeFileError = false;
      this.documentAssignExtensionFileError = false;
    }
  }

  // Guarda el documento para ese tipo y los comercios seleccionados
  SaveDocumentAssigment() {
    // obtenemos la lista actual
    // let currentDocumentAssigments =
    //   this.documentAssignments[this.modalSelectedType];
    // // creamos un nuevo elemento para la lista
    // let newAssignedDocument = new AssignedDocuments();
    // newAssignedDocument.documentName = this.documentAssignName;
    // newAssignedDocument.documentBase64 = this.documentAssignFileBase64;
    // newAssignedDocument.documentType = this.documentAssignType;
    // newAssignedDocument.assignedContacts = this.lstContacts.filter(
    //   (contact) => this.documentAssignSelectedContacts[contact.contactId]
    // );
    // currentDocumentAssigments.push(newAssignedDocument);
    // // guardamos el nuevo elemento en la lista
    // this.documentAssignments[this.modalSelectedType] =
    //   currentDocumentAssigments;

    // Se completa el objeto request del endpoint commercefiles
    this.parameters.contacts = new Array();
    let extension = this.documentAssignName.split('.');
    this.parameters.extension = extension[1];
    this.parameters.fileName = this.documentAssignName;
    this.parameters.documentType = this.modalSelectedType;
    // switch (this.modalSelectedType) {
    //   case 'SaleConditions':
    //     this.parameters.documentType = 'GENERAL_CONDITIONS';
    //     break;
    //   case 'CancellationPolicy':
    //     this.parameters.documentType = 'CANCELLATION_POLICY';
    //     break;
    //   case 'PurchaseProcess':
    //     this.parameters.documentType = 'DENIAL_POLICY';
    //     break;
    //   case 'OtherDocuments':
    //     this.parameters.documentType = 'OTHER_DOCUMENTS';
    //     break;
    // }

    let today = new Date();
    this.parameters.created = today;
    this.parameters.createdBy = this.tokenData.name;
    this.parameters.contacts = this.lstContacts.filter(
      (contact) => this.documentAssignSelectedContacts[contact.contactId],
    );

    // newAssignedDocument.assignedContacts.forEach(element => {
    //   this.parameters.contacts.push(element)
    // });
    this.parameters.file = this.documentAssignFileBase64;
    // console.log(this.parameters);
    //// console.log(newAssignedDocument.assignedContacts)

    this.CommerceFileDocumentService.PostCommerceFileDocument(this.parameters).subscribe({
      next: (response) => {
        // console.log('next:(response)');
        // commercefileId
        // limpiamos los datos
        this.ClearUploadedDocument();
        this.boolAnyContactsAssigned = false;
        this.boolCheckedAll = false;
        this.ContactsSetDefaultDictionary();
        // Se hace la llamada al endpoint para conseguir los documentos de cada documentType
        this.CommerceFileDocumentService.GetCommerceFileDocument(
          this.modalSelectedType,
        ).subscribe({
          next: (response) => {
            //this.getCommercefilesDocument = response;
            //let assignedDocumentsAux = [];
            //Se recorre el objeto recibido para mapear los campos con el modelo que se utiliza en el front
            /*for(let i=0; i<this.getCommercefilesDocument.length; i++){
      let assignedDocument = new AssignedDocuments();
      assignedDocument.documentName = this.getCommercefilesDocument[i].fileName;
      assignedDocument.documentType = this.getCommercefilesDocument[i].documentType;
      assignedDocument.commerceFileId = this.getCommercefilesDocument[i].commerceFileId;
      assignedDocument.assignedContacts = new Array();
      //Se recorre el objeto de contact para mapearlo con el objeto assignedContacts usado en front
      for(let z=0; z<this.getCommercefilesDocument[i].contacts.length; z++){
        assignedDocument.assignedContacts[z] = new Contact();
        assignedDocument.assignedContacts[z].commerceName = this.getCommercefilesDocument[i].contacts[z].commerceName;
        assignedDocument.assignedContacts[z].commerceNumber = this.getCommercefilesDocument[i].contacts[z].commerceNumber;
        assignedDocument.assignedContacts[z].contactId = this.getCommercefilesDocument[i].contacts[z].contactId;
      }
    //se alimenta el array con el objeto individual de cada documento
      //assignedDocumentsAux.push(assignedDocument);
    }*/
            //Se añade cada objeto de documento en el documentType correspondiente

            this.documentAssignments[this.modalSelectedType] = response;
            // console.log(this.documentAssignments);
            //// console.log(this.getCommercefilesDocument)
          },
        });

        // cerrar modal
        $(this.modalAssingDocuments.nativeElement).modal('hide');
        // abrir modal confirmación
        $(this.modalPostFile.nativeElement).modal('show');
      },
      error: (errorResponse) => {
        // console.log('error:(errorResponse)');
        // console.log(errorResponse);
        if (errorResponse.status == 409) {
          // significa que el documento no le gusta
          this.documentAssignFileError = true;
          this.documentAssignFileBase64 = '';
          this.modalFileInput.nativeElement.value = '';
        }
      },
      complete() {
        // console.log('complete');
      },
    });
  }
  ClearUploadedDocument() {
    this.documentAssignFileBase64 = '';
    this.documentAssignName = '';
    this.documentAssignSize = 0;
    this.documentAssignType = '';
    this.modalFileInput.nativeElement.value = '';
    this.documentAssignFileError = false;
  }

  GoBack() {
    this.router.navigate([Routes.CONTACT_DATA]);
  }

  DisableContinue(): boolean {
    let disabled = true;

    this.documentTypes
      .filter((type) => type !== 'OTHER_DOCUMENTS')
      .map((type) => {
        const total = this.documentAssignments[type]
          .map(
            (da) =>
              da.contacts.filter((c) =>
                this.lstContacts.some((lc) => lc.contactId === c.contactId),
              ).length,
          )
          .reduce((acc, n) => acc + n, 0);

        disabled = total !== this.lstContacts.length;
      });

    return disabled;
  }

  // actualizamos enrollment
  async updateEnrollment(): Promise<void> {
    try {
      await this.authService.UpdateEnrolment(this.tokenData.id);
      let contactGroupId = this.contactGroupId;
      this.router.navigate(['/end-enrollment'], {
        queryParams: { contactGroupId },
      });
    } catch (error) {
      console.error('Error updating enrollment', error);
    }
  }

  goHome() {
    this.router.navigate([Routes.DEFAULT]);
  }
}
